// extracted by mini-css-extract-plugin
module.exports = {"companySelect":"styles_companySelect__kgkbI"};